export default __webpack_public_path__ + "static/media/fish&chips-bold.d70e9eb4.eot";